// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"cac02978","143":"d7bee19a","308":"3908c4f4","411":"f61c1f7c","475":"4395e66b","614":"3ada3d8b","874":"04e3ad74","922":"51ca338e","954":"ec570409"}[chunkId] + ".chunk.css";
};